export var ChartType;
(function (ChartType) {
    ChartType[ChartType["Areas"] = 0] = "Areas";
    ChartType[ChartType["Bubbles"] = 1] = "Bubbles";
    ChartType[ChartType["Bars"] = 2] = "Bars";
    ChartType[ChartType["SimpleBars"] = 3] = "SimpleBars";
    ChartType[ChartType["MixedBars"] = 4] = "MixedBars";
    ChartType[ChartType["StackedBars"] = 5] = "StackedBars";
    ChartType[ChartType["WinLossBars"] = 6] = "WinLossBars";
    ChartType[ChartType["Bullet"] = 7] = "Bullet";
    ChartType[ChartType["Columns"] = 8] = "Columns";
    ChartType[ChartType["Dots"] = 9] = "Dots";
    ChartType[ChartType["Lines"] = 10] = "Lines";
    ChartType[ChartType["Pies"] = 11] = "Pies";
    ChartType[ChartType["Gauges"] = 12] = "Gauges";
    ChartType[ChartType["Counter"] = 13] = "Counter";
    ChartType[ChartType["Counters"] = 14] = "Counters";
    ChartType[ChartType["Ring"] = 15] = "Ring";
    ChartType[ChartType["Funnel"] = 16] = "Funnel";
})(ChartType || (ChartType = {}));
;
